import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { Day } from './Day';
import { StyledMonth, StyledMonthTable, StyledWeekDayName } from './Month.styled';
export function Month(props) {
  var daysOfWeek = props.weeks[0].slice(0, 7).map(function (weekday) {
    return weekday.date.toLocaleDateString(getLanguage(), {
      weekday: 'short'
    }).toLocaleUpperCase();
  });
  return /*#__PURE__*/React.createElement(StyledMonth, null, /*#__PURE__*/React.createElement(StyledMonthTable, {
    cellSpacing: 0,
    cellPadding: 0
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, daysOfWeek.map(function (day) {
    return /*#__PURE__*/React.createElement(StyledWeekDayName, {
      key: day
    }, day);
  })), props.weeks.map(function (weekDays, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, weekDays.map(function (day) {
      return /*#__PURE__*/React.createElement(Day, _extends({
        key: day.date.toISOString()
      }, day, {
        onClick: props.onDateClick,
        onFocus: props.onFocusChange
      }));
    }));
  }))));
}